import * as React from "react";

export const ChevronIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
}> = ({ className, size = 16, color = "var(--color-color-accent)" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={Math.round(size * 9 / 16)}
    viewBox="0 0 16 9"
    className={className}
    fill="none"
  >
    <path
      d="M15 1L8 8L1 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
